import React from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';

import { colorValue } from '../../../../lib/theme';

const StyledSpan = styled.span`
  font-size: 14px;
  color: ${({ theme }) => colorValue(theme, c => c['grey-60'])};
`;

interface Props {
  date?: string;
  i18TitleId?: string | null;
}

const ProcessingDateLabel: React.FC<Props> = ({ i18TitleId, date }) => {
  const { t } = useTranslation();
  const label = t(i18TitleId === null ? 'formattedDate' : i18TitleId ?? 'overview.asOfDate', { date });
  // @ts-ignore
  return <StyledSpan>{date ? label : ''}</StyledSpan>;
};

export default ProcessingDateLabel;
